var rasterScan =
webpackJsonp_name_([6],{

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var eRASTERPARMS = exports.eRASTERPARMS = {
    MODE: 0,
    MAG: 1,
    OVERLAPPCT: 2,
    PATTERNNAME: 3,
    PATTERNNUMBER: 4,
    PATTERNLIST: 5,
    PIXELTHRESH: 6,
    CONTENTPCT: 7,
    SPEEDFACTOR: 8,
    SEQUENCESTYLE: 9
};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(559);

__webpack_require__(434);

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BlobAnalysisService;

var _helpers = __webpack_require__(4);

//________________________________________________________________________________________________
// imageproc.js
//    This file contains the constructor for a viewport and its associated tile management methods.
//
//    history
//    _______________________________________end_AIHv1/PR __________________________________________
//
//-------------------------------------------------------------------------------------------------
//    BLOB ANALYSIS OBJECT
//-------------------------------------------------------------------------------------------------
//
// suggested improvements:
//        - rename 'l' to be 'label' !
//
function BlobAnalysisService(uScope) {
    //............................................ detect public
    // This function performs connected-component labeling (aka blob extraction)
    // Using Algorithm developed in "A linear-time component labeling algorithm using contour tracing technique"
    this.detect = function (data, w, h) {
        var max = w * h;
        var BACKGROUND = 255;
        var FOREGROUND = 0;
        var UNSET = 0;
        var MARKED = -1;

        /*
         * 5 6 7
         * 4 P 0
         * 3 2 1
         */
        var pos = [1, w + 1, w, w - 1, -1, -w - 1, -w, -w + 1]; // Clockwise

        var label = []; // Same size as data
        var c = 1; // Component index

        // We change the border to be white. We could add a pixel around
        // but we are lazy and want to do this in place.
        // Set the outer rows/cols to min
        (0, _helpers.memset)(data, 0, w, BACKGROUND); // Top
        (0, _helpers.memset)(data, w * (h - 1), w, BACKGROUND); // Bottom

        for (var y = 1; y < h - 1; y++) {
            var offset = y * w;
            data[offset] = BACKGROUND; // Left
            data[offset + w - 1] = BACKGROUND; // Right
        }

        (0, _helpers.memset)(label, 0, max, UNSET); // Set labels to zeros

        var tracer = function tracer(S, p) {
            for (var d = 0; d < 8; d++) {
                var q = (p + d) % 8;

                var T = S + pos[q];
                if (T < 0 || T >= max) // Make sure we are inside image
                    continue;

                if (data[T] != BACKGROUND) return { T: T, q: q };

                //assert(label[T] <= UNSET);
                label[T] = MARKED;
            }
            return { T: S, q: -1 }; // No move
        };

        /**
         *
         * @param S Offset of starting point
         * @param C label count
         * @param external Boolean Is this internal or external tracing
         */
        var contourTracing = function contourTracing(S, C, external) {
            var p = external ? 7 : 3;

            var tmp = tracer(S, p); // Find out our default next pos (from S)
            var T2 = tmp.T;
            var q = tmp.q;

            label[S] = C;

            if (T2 == S) // Single pixel check
                return;

            var counter = 0;

            var Tnext = T2;
            var T = T2;

            while (T != S || Tnext != T2) {
                //assert(counter++ < max, "Looped too many times!");

                label[Tnext] = C;

                T = Tnext;
                p = (q + 5) % 8;

                tmp = tracer(T, p);
                Tnext = tmp.T;
                q = tmp.q;
            }
        };

        var extract = function extract() {
            var y = 1; // We start at 1 to avoid looking above the image
            do {
                var x = 0;
                do {
                    var offset = y * w + x;
                    if (data[offset] == BACKGROUND) // We skip white pixels or previous labeled pixels
                        continue;

                    var traced = false;

                    // Step 1 - P not labelled, and above pixel is white
                    if (data[offset - w] == BACKGROUND && label[offset] == UNSET) {
                        contourTracing(offset, c, true); // P must be external contour
                        c++;
                        traced = true;
                    }

                    // Step 2 - Below pixel is white, and unmarked
                    if (data[offset + w] == BACKGROUND && label[offset + w] == UNSET) {
                        var n = label[offset - 1]; // Use previous pixel label, unless this is already labelled
                        if (label[offset] != UNSET) n = label[offset];

                        //assert(n > UNSET, "Step 2: N must be set, (" + x + "," + y + ") " + n + " " + data[offset - 1]);
                        contourTracing(offset, n, false); // P must be a internal contour
                        traced = true;
                    }

                    // Step 3 - Not dealt with in previous two steps
                    if (label[offset] == UNSET) {
                        var n = label[offset - 1];
                        label[offset] = n; // Assign P the value of N
                    }
                } while (x++ < w);
            } while (y++ < h - 1); // We end one before the end to to avoid looking below the image

            return label;
        };
        return extract();
    };

    //............................................ getBlobs public
    // This function returns an array of each blob's bounds
    this.getBlobs = function (labelMask1D, width, height) {
        var blob = [];
        var offset = 0;
        for (var y = 0; y < height; y++) {
            for (var x = 0; x < width; x++) {
                var l = labelMask1D[offset++]; // get this pixel's label

                if (l <= 0) continue;

                if (l in blob) {
                    // if already have this blob label in the blob array
                    var b = blob[l];

                    if (b.x2 < x) // update bounding box coords: x1 and x2,y2
                        b.x2 = x;
                    if (b.x1 > x) b.x1 = x;
                    b.y2 = y; // as we are going from top down, the bottom y should increase
                } else {
                    // add new blob to the blob array

                    blob[l] = { valid: true, l: l, x1: x, y1: y, x2: x, y2: y };
                }
            }
        }

        blob[0] = {
            valid: true, l: 0, x1: 0, y1: 0, x2: width - 1, y2: height - 1,
            width: width, height: height, area: width * height
        };

        for (var i = 1; i < blob.length; i++) {
            var b = blob[i];
            b.width = b.x2 - b.x1 + 1;
            b.height = b.y2 - b.y1 + 1;
            b.area = b.width * b.height;
        }
        return blob;
    };

    //............................................ addBlobEdges
    // This function builds an array of the blob edges for each valid blob.
    //    Note that the edges are not always connected.  They are not a trace but just a list.
    //    Note that the edges of blob[0] are not computed as it identifies the whole image bounds.
    //todo: probably because of the 1 pixel boundary in detect(),
    //        the blob edges appear to be off one pixel left and top.  So this fn adds one to each edge point.
    this.addBlobEdges = function (blobArray, labelMask1D) {
        if (blobArray.length == 0) return;
        var widthImg = blobArray[0].width,
            heightImg = blobArray[0].height;

        for (var i = 1; i < blobArray.length; i++) {
            var blob = blobArray[i];
            if (blob.valid == false) continue;
            var thisLabel = blob.l;
            var edges = [];

            var left = blob.x1,
                top = blob.y1; // blob bounding box
            var width = blob.width,
                height = blob.height;

            // get left and right boundarys ................
            var offset = 0;
            for (var y = top; y < top + height; y++) {
                offset = y * widthImg + left; // row offset left side
                for (var x = left; x < left + width; x++, offset++) {
                    if (labelMask1D[offset] <= 0) // this pixel does not belong to this blob
                        continue;
                    if (labelMask1D[offset] == thisLabel) {
                        edges.push({ x: x + 1, y: y + 1 }); // add the left boundary coord
                        //    edges.push({ x: x, y: y });         // add the left boundary coord
                        break;
                    }
                }

                offset = y * widthImg + left + width - 1; // row offset right side
                for (var x = left + width - 1; x >= left; x--, offset--) {
                    if (labelMask1D[offset] <= 0) // this pixel does not belong to this blob
                        continue;
                    if (labelMask1D[offset] == thisLabel) {
                        edges.push({ x: x + 1, y: y + 1 }); // add the right boundary coord
                        //    edges.push({ x: x, y: y });         // add the right boundary coord
                        break;
                    }
                }
            }

            // get top and bottom boundarys ................
            for (var x = left; x < left + width; x++, offset++) {
                offset = x + top * widthImg; // col offset top side
                for (var y = top; y < top + height; y++, offset += widthImg) {
                    if (labelMask1D[offset] <= 0) // this pixel does not belong to this blob
                        continue;
                    if (labelMask1D[offset] == thisLabel) {
                        edges.push({ x: x + 1, y: y + 1 }); // add the top boundary coord
                        //    edges.push({ x: x, y: y });         // add the top boundary coord
                        break;
                    }
                }
            }
            for (var x = left; x < left + width; x++, offset++) {
                offset = (top + height) * widthImg + x;
                for (var y = top + height - 1; y >= top; y--, offset -= widthImg) {
                    if (labelMask1D[offset] <= 0) // this pixel does not belong to this blob
                        continue;
                    if (labelMask1D[offset] == thisLabel) {
                        edges.push({ x: x + 1, y: y + 1 }); // add the bottom boundary coord
                        //    edges.push({ x: x, y: y });         // add the bottom boundary coord

                        break;
                    }
                }
            }
            blob.edges = edges; // add edge list to blob
        }
    };

    //............................................ addBlobContours
    // This function traces the blob contours and adds them to the blob array
    //
    //    http://en.wikipedia.org/wiki/Moore_neighborhood
    //  The following is a formal description of the Moore-Neighbor tracing algorithm:
    //        Input: A square tessellation, T, containing a connected component P of black cells.
    //        Output: A sequence B (b1, b2, ..., bk) of boundary pixels i.e. the contour.
    //        Define M(a) to be the Moore neighborhood of pixel a. Let p denote the current boundary pixel.
    //        Let c denote the current pixel under consideration i.e. c is in M(p).
    //        Let b denote the backtrack of c (i.e. neighbor pixel of p that was previously tested)
    //
    //        The original termination condition was to stop after visiting the start pixel for the second time.
    //        This limits the set of contours the algorithm will walk completely. An improved stopping condition
    //        proposed by Jacob Eliosoff is to stop after entering the start pixel for the second time in the same
    //        direction you originally entered it.
    //  Begin
    //  Set B to be empty.
    //  From bottom to top and left to right scan the cells of T until a black pixel, s, of P is found.
    //  Insert s in B.
    //  Set the current boundary point p to s i.e. p=s
    //  b = the pixel from which s was entered during the image scan.
    //  Set c to be the next clockwise pixel (from b) in M(p).
    //  While c not equal to s do
    //    If c is black
    //      insert c in B
    //      b = p
    //      p = c
    //      (backtrack: move the current pixel c to the pixel from which p was entered)
    //      c = next clockwise pixel (from b) in M(p).
    //    else
    //      (advance the current pixel c to the next clockwise pixel in M(p) and update backtrack)
    //      b = c
    //      c = next clockwise pixel (from b) in M(p).
    //    end While
    //  End
    //todo: not implemented, not tested yet
    //    this.addBlobContours = function (blob, labelImg2D, width, height) {
    //        for (var i = 0; i < blob.length; i++) {
    //            blob[i].outline = undefined;
    //            var b = blob[i];
    //            if (b.valid == false)
    //                continue;
    //
    //            var label = b.l;
    //            var labelFound = false;
    //            var y0 = b.y1, x0 = b.x1;
    //            do {                                            // find a starting edge pixel for this blob
    //                if (labelImg2D[x0][y0] == label) {
    //                    labelFound = true;
    //                    break;
    //                }
    //                if (++x0 > b.x2) {    // step x, end of row?
    //                    x0 = b.x1;         // step to the begining of the next row
    //                    y0++;
    //                }
    //            } while (y0 < b.y2);
    //            if (labelFound == false)    // this should not happen
    //                continue;
    //
    //            var outline = []; // trace the blob
    //            outline.push({ x: x0, y: y0 }); // starting point
    //            var count = 0, maxCount = b.width * b.height; // safety measures in case loop goes mad
    //            var xc = x0, yc = y0; //current pixel coords
    //            do {
    //                if (yc > 0 && labelImg2D[xc][yc - 1] == label) { // look one pixel above
    //                    yc = yc - 1;
    //                    outline.push({ x: xc, y: yc }); // starting point
    //                }
    //                else if () { // look to the right
    //                }
    //
    //            } while (count < maxCount);
    //
    //        }
    //    };

    //............................................ color
    // This function draws a picture with each blob coloured
    this.color = function (dest, width, height, labels) {
        // TODO: rect is undefined and it's not clear what the original was supposed to be pointing to
        // TODO: Confirm uScope.rootRectGet() is what the original was expecting
        var rect = uScope.rootRectGet();
        var max = rect.width * rect.height;
        var colors = [];

        var maxcolors = Array.max(labels);
        var maxcolors2 = maxcolors / 2;

        // Create a simple color scale (I could do this in two loops but I'm lazy)
        for (var i = 0; i <= maxcolors; i++) {
            var r = i <= maxcolors2 ? 1 - i / maxcolors2 : 0;
            var g = i <= maxcolors2 ? i / maxcolors2 : 1 - (i - maxcolors2) / maxcolors2;
            var b = i <= maxcolors2 ? 0 : (i - maxcolors2) / maxcolors2;

            colors[i] = [r * 255, g * 255, b * 255];
        }

        var offset = max - 1;
        var destOffset = offset * 4;
        do {
            var l = labels[offset];

            var color = l > 0 ? colors[l] : [0, 0, 0];
            dest[destOffset] = color[0];
            dest[destOffset + 1] = color[1];
            dest[destOffset + 2] = color[2];
            dest[destOffset + 3] = 0xff; // Alpha

            destOffset -= 4;
        } while (offset--);
    };
}
module.exports = exports['default'];

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RasterPanel;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _constants = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RasterPanel(uScope) {
    //todo: when a setting is changed it must be changed for ALL images

    var self = this;
    var jPanel;
    var jProgressBar;
    var tbOpenIcon = void 0;
    var isDialogVisible = false;

    //............................................ close() public
    // This function closes the raster panel;
    this.close = function () {
        jPanel.dialog('close');
    };
    //............................................ start() public
    // This function clicks the raster panel start button which
    //    sets the panel state and calls the rasterScan object's start()
    this.start = function () {
        $('.' + _defines2.default.RPSTART).click();
    };
    //............................................ pause() public
    // This function clicks the raster panel pause button which
    //    sets the panel state and calls the rasterScan object's stop()
    this.pause = function () {
        $('.' + _defines2.default.RPPAUSE).click();
    };
    //............................................ configure_()
    var configure_ = function configure_() {
        if (uScope.isThisImageValid()) {
            var thisImg = uScope.getThisImage();
            if (thisImg && thisImg.rasterScan) {

                var rasterObj = thisImg.rasterScan;
                var rasterMag = rasterObj.parmAction('get', _constants.eRASTERPARMS.MAG);
                var rasterMode = rasterObj.parmAction('get', _constants.eRASTERPARMS.MODE);
                var info = rasterMode + ' Scan at ' + rasterMag + 'X';
                $('#' + _defines2.default.idRPTEXT).text(info);
                var instr = rasterMode == 'Manual' ? 'SpaceBar Steps the View' : 'SpaceBar to Pause/Resume';
                $('#' + _defines2.default.idRPINSTR).text(instr);

                // set the checked state of the sequence style
                var segValue = rasterObj.parmAction('get', _constants.eRASTERPARMS.SEQUENCESTYLE);
                var btnSel = $('.' + _defines2.default.clsSEQUENCESTYLE)[segValue];
                btnSel.children[0].checked = true; // check current raster scan segmentation type
                $(btnSel).addClass(_defines2.default.clsRSSTYLESEL); // add selected state to this button
            }
        }
    };
    //............................................ show() local
    var show = function show(_show) {
        if (_show == true) {
            jPanel.dialog('open');
            configure_();
        } else {
            jPanel.dialog('close');
        }
    };
    //............................................ isOpen() public
    this.isOpen = function () {
        return jPanel && jPanel.hasClass('ui-dialog-content') && jPanel.dialog('isOpen') ? true : false;
    };
    //............................................ settingsAdv_() local
    var settingsAdv_ = function settingsAdv_() {
        if ($(_defines2.default.idHashROOT).find('#' + _defines2.default.idRASTERSETADV).length > 0) return; // already open, then return
        if (uScope.isThisImageValid() == false) return false;
        var thisImg = uScope.getThisImage(); // there must be a valid image
        var rasterObj = thisImg.rasterScan;

        var jSettingsAdv = $('<div/>', {
            'id': _defines2.default.idRASTERSETADV,
            'class': _defines2.default.clsPANEL + ' ' + _defines2.default.clsPANELCLICKCLOSE,
            'title': 'Advanced Raster Settings'
        });

        //................................................. // raster view overlap selection
        jSettingsAdv.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));

        var strSelect = '<select id"' + _defines2.default.idRPOVERLAP + '" class="' + _defines2.default.clsSELECTBOX + '" style="width: 110px" title="Select raster view overlap">';
        for (var m = 10; m < 100; m += 10) {
            strSelect += '<option  value="' + m + '">&nbsp;' + m + '%</option>';
        }strSelect += '</select>';
        var jOverlap = $(strSelect);

        jOverlap.change(function () {
            var value = parseInt(jOverlap[0][jOverlap[0].selectedIndex].value);
            rasterObj.parmAction('set', _constants.eRASTERPARMS.OVERLAPPCT, value);
        });
        jOverlap.set = function () {
            var overlapSelected = rasterObj.parmAction('get', _constants.eRASTERPARMS.OVERLAPPCT);
            for (var o = 0; o < jOverlap[0].length; o++) {
                if (jOverlap[0][o].value == overlapSelected) {
                    jOverlap[0].selectedIndex = o;
                    break;
                }
            }
        };
        jOverlap.set();
        jSettingsAdv.append(jOverlap);
        jSettingsAdv.append($('<span>&nbsp;View Overlap</span>'));

        //................................................. // raster pattern selection
        jSettingsAdv.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));
        var strSelect = '<select id="' + _defines2.default.idRPPATTERN + '" class="' + _defines2.default.clsSELECTBOX + '" style="width: 110px" title="Select raster pattern">';
        var list = rasterObj.parmAction('get', _constants.eRASTERPARMS.PATTERNLIST);
        for (var m = 0; m < list.length; m++) {
            strSelect += '<option  value="' + list[m].name + '">&nbsp;' + list[m].name + '</option>';
        }strSelect += '</select>';
        var jPattern = $(strSelect);

        jPattern.change(function () {
            var idx = jPattern[0].selectedIndex;
            var value = jPattern[0][idx].value;
            rasterObj.parmAction('set', _constants.eRASTERPARMS.PATTERNNAME, value);
        });
        jPattern.set = function () {
            var patternSelected = rasterObj.parmAction('get', _constants.eRASTERPARMS.PATTERNNAME);
            for (var o = 0; o < jPattern[0].length; o++) {
                if (jPattern[0][o].value == patternSelected) {
                    jPattern[0].selectedIndex = o;
                    break;
                }
            }
        };
        jPattern.set();
        jSettingsAdv.append(jPattern);
        jSettingsAdv.append($('<span>&nbsp;Raster Pattern</span>'));

        //................................................. // raster threshold selection
        jSettingsAdv.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));
        var strSelect = '<select id="' + _defines2.default.idRPTHRESHOLD + '" class="' + _defines2.default.clsSELECTBOX + '" style="width: 110px" title="For Bright Field images, choose higher value to include light tissue.  For Fluorescence images, choose a lower value to include dark tissue.">';
        if (thisImg.getCaptureType() == _defines2.default.eAICCaptureType.aic_i_FL) for (var m = 5; m < 50; m += 5) {
            strSelect += '<option  value="' + m + '">&nbsp;' + m + '</option>';
        } else for (var m = 170; m < 230; m += 10) {
            strSelect += '<option  value="' + m + '">&nbsp;' + m + '</option>';
        }
        strSelect += '</select>';
        var jPixelThresh = $(strSelect);

        jPixelThresh.change(function () {
            var idx = jPixelThresh[0].selectedIndex;
            var value = parseInt(jPixelThresh[0][idx].value);
            rasterObj.parmAction('set', _constants.eRASTERPARMS.PIXELTHRESH, value);
        });
        jPixelThresh.set = function () {
            var pixelThresh = rasterObj.parmAction('get', _constants.eRASTERPARMS.PIXELTHRESH);
            for (var o = 0; o < jPixelThresh[0].length; o++) {
                if (jPixelThresh[0][o].value == pixelThresh) {
                    jPixelThresh[0].selectedIndex = o;
                    break;
                }
            }
        };
        jPixelThresh.set();
        jSettingsAdv.append(jPixelThresh);
        jSettingsAdv.append($('<span>&nbsp;Tissue Threshold</span>'));

        //................................................. // default button
        jSettingsAdv.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));
        jSettingsAdv.append($('<button/>', {
            'id': _defines2.default.idRPSETTINGSDEF, 'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.clsSETBUTTON,
            'text': 'Default', 'title': 'Reset above settings to default values',
            click: function click() {
                rasterObj.parmAction('default', _constants.eRASTERPARMS.OVERLAPPCT);
                jOverlap.set();
                rasterObj.parmAction('default', _constants.eRASTERPARMS.PATTERNNAME);
                jPattern.set();
                rasterObj.parmAction('default', _constants.eRASTERPARMS.PIXELTHRESH);
                jPixelThresh.set();
            }
        }));

        //................................................. // position and open the raster advanced settings panel
        var offsetPos = $('#' + _defines2.default.idRASTERSETTINGS).offset();
        if (offsetPos == null || offsetPos == undefined) offsetPos = { 'left': 0, 'top': 0 };
        jSettingsAdv.dialog({
            autoOpen: true,
            left: offsetPos.left,
            top: offsetPos.top,
            closeOnEscape: true,
            resizable: false,
            width: 260,
            height: 230,
            dialogClass: 'uscope-dialog dialogMover',
            appendTo: _defines2.default.idHashROOT,
            open: function open() {
                // Because the raster panels open sequential dialogs the normal CSS/DOM stacking mechanism doesn't
                // work. Call `moveToTop` to ensure these dialogs don't appear behind each-other. Since this one is triggered
                // by a click on it's parent dialog, `moveToTop` is called internally on the parent, making it appear on
                // top of this, its child. Deferring execution allows the window to account for this.
                window.setTimeout(function () {
                    jSettingsAdv.dialog('moveToTop');
                });
                isDialogVisible = true;
            },
            close: function close(event, ui) {
                // remove this panel and the raster settings panel
                $(this).remove();
                $('#' + _defines2.default.idRASTERSETTINGS).remove();
                isDialogVisible = false;
            }
        });
    };

    //............................................ settings_() local
    var settings_ = function settings_() {
        if ($(_defines2.default.idHashROOT).find('#' + _defines2.default.idRASTERSETTINGS).length > 0) return; // already open, then return
        if (uScope.isThisImageValid() == false) return false;
        var thisImg = uScope.getThisImage(); // there must be a valid image
        var rasterObj = thisImg.rasterScan;

        var jSettings = $('<div/>', {
            'id': _defines2.default.idRASTERSETTINGS,
            'class': _defines2.default.clsPANEL + ' ' + _defines2.default.clsPANELCLICKCLOSE,
            'title': 'Raster Settings'
        });

        //................................................. // raster mode selection
        var jMode = $('<input type="checkbox" class="ui-corner-all"  id="' + _defines2.default.idRASTERMODE + '" /><label for="' + _defines2.default.idRASTERMODE + '">&nbsp;Auto Scan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>');
        jMode.change(function () {
            var newMode = rasterObj.parmAction('toggle', _constants.eRASTERPARMS.MODE);
            configure_();
        });
        jMode.attr('title', 'Manual or Automatic Raster Scanning');
        jMode.set = function () {
            jMode.prop('checked', rasterObj.parmAction('get', _constants.eRASTERPARMS.MODE) == 'Automatic' ? true : false);
        };
        jMode.set(); // initialize check state
        jSettings.append(jMode);

        //................................................. // raster magnification selection
        var magList = thisImg.getFixedZoomArray();
        var magSelected = rasterObj.parmAction('get', _constants.eRASTERPARMS.MAG);

        var strSelect = '<select id="' + _defines2.default.idRASTERMAG + '" class="' + _defines2.default.clsSELECTBOX + '>';
        for (var m = 0, len = magList.length; m < len; m++) {
            var mag = magList[m].mag;
            if (mag != 'Fit' && mag > 1) {
                strSelect += '<option  value="' + mag + '">&nbsp;' + mag + 'X</option>';
            }
        }
        strSelect += '</select>';
        var jMagnification = $(strSelect);
        jMagnification.attr('title', 'Select Raster Scan Magnification'); //add tooltip

        jMagnification.change(function () {
            var value = parseInt(jMagnification[0][jMagnification[0].selectedIndex].value);
            rasterObj.parmAction('set', _constants.eRASTERPARMS.MAG, value);
            configure_();
        });
        jMagnification.set = function () {
            var magSelected = rasterObj.parmAction('get', _constants.eRASTERPARMS.MAG);
            for (var o = 0; o < jMagnification[0].length; o++) {
                if (jMagnification[0][o].value == magSelected) {
                    jMagnification[0].selectedIndex = o;
                    break;
                }
            }
        };
        jMagnification.set();
        jSettings.append(jMagnification);
        jSettings.append($('<span>Magnfication&nbsp;</span>'));

        //................................................. // default button
        jSettings.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));
        jSettings.append($('<button/>', {
            id: _defines2.default.idRPSETTINGSDEF,
            class: _defines2.default.clsRPBUTTON + ' ' + _defines2.default.clsSETBUTTON,
            text: 'Default',
            title: 'Reset above settings to default values',
            click: function click() {
                rasterObj.parmAction('default', _constants.eRASTERPARMS.MODE);
                jMode.set();
                rasterObj.parmAction('default', _constants.eRASTERPARMS.MAG);
                jMagnification.set();
                configure_();
            }
        }));

        //................................................. // advanced settings button
        jSettings.append($('<a/>', {
            id: _defines2.default.RPSETTINGSADV,
            class: _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPSETTINGSADV,
            title: 'Advanced Settings',
            click: function click() {
                settingsAdv_();
            }
        }));

        //................................................. // position and open the RASTER settings panel
        var offsetPos = $('#' + _defines2.default.idRASTERPANEL).offset();
        if (offsetPos == null || offsetPos == undefined) offsetPos = { 'left': 0, 'top': 0 };
        jSettings.dialog({
            autoOpen: true,
            left: offsetPos.left,
            top: offsetPos.top,
            closeOnEscape: true,
            resizable: false,
            width: 260,
            height: 140,
            dialogClass: 'uscope-dialog dialogMover',
            open: function open() {
                // Because the raster panels open sequential dialogs the normal CSS/DOM stacking mechanism doesn't
                // work. Call `moveToTop` to ensure these dialogs don't appear behind each-other. Since this one is triggered
                // by a click on it's parent dialog, `moveToTop` is called internally on the parent, making it appear on
                // top of this, its child. Deferring execution allows the window to account for this.
                window.setTimeout(function () {
                    jSettings.dialog('moveToTop');
                });
            },
            close: function close(event, ui) {
                $(this).remove(); // remove this panel and change the icon
                (0, _toolbar.setIconState)($('#' + _defines2.default.RPSETTINGS), _defines2.default.RPSETTINGS, 'enabled');
            }
        });

        //................................................. // append this modeless dialog to uscope's root div - the dialog is the parent to the panel created
        jSettings.parent().appendTo(_defines2.default.idHashROOT);
    };

    //............................................ init_() local
    //    init_ - This function creates and intializes the RASTER panel
    var init_ = function init_() {
        uScope.events.on('uscope:resize', self.position);

        if (jPanel != undefined) {
            jPanel.remove();
        }

        jPanel = $('<div id=' + _defines2.default.idRASTERPANEL + ' class=' + _defines2.default.clsPANEL + ' title="Raster"></div>');

        jPanel.append($('<a/>', {
            'id': _defines2.default.RPSETTINGS,
            'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPSETTINGS,
            'title': 'Change Settings'
        }));
        jPanel.append($('<div/>', { 'id': _defines2.default.idRPTEXT, 'text': ' Raster Scan' }));
        jPanel.append($('<div/>', { 'id': _defines2.default.idRPINSTR, 'text': '' }));

        jPanel.append($('<a/>', {
            'id': _defines2.default.RPBACKUP,
            'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPBACKUP,
            'title': 'Reset Progress'
        }));
        jPanel.append($('<a/>', {
            'id': _defines2.default.RPSLOW,
            'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPSLOW + '-d',
            'title': 'Slow Down'
        }));
        jPanel.append($('<a/>', {
            'id': _defines2.default.RPSTART,
            'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPSTART,
            'title': 'Start Raster Scan'
        }));
        jPanel.append($('<a/>', {
            'id': _defines2.default.RPFAST,
            'class': _defines2.default.clsRPBUTTON + ' ' + _defines2.default.RPFAST + '-d',
            'title': 'Speed Up'
        }));

        jPanel.append($('<div/>', { 'class': 'tooldivider', css: { 'visibility': 'hidden' } }));
        var jBarDiv = $('<div/>', { 'id': _defines2.default.RPRASTERBAR, 'title': 'Raster Progress' });
        jBarDiv.append($('<div/>'));
        jPanel.append(jBarDiv);

        jPanel.dialog({
            autoOpen: false,
            closeOnEscape: true,
            resizable: false,
            width: 240,
            height: 'auto',
            minHeight: 0,
            dialogClass: 'uscope-dialog dialogMover',
            appendTo: _defines2.default.idHashROOT,
            open: function open(event, ui) {
                if (uScope.isThisImageValid() == true) {
                    var thisImg = uScope.getThisImage();
                    (0, _toolbar.setIconState)(tbOpenIcon, _defines2.default.TBRASTEROPEN, 'active');
                    if (thisImg.rasterScan != undefined) {
                        thisImg.rasterScan.onPanelOpen();
                    }
                }
            },
            close: function close(event, ui) {
                (0, _toolbar.setIconState)(tbOpenIcon, _defines2.default.TBRASTEROPEN, 'enabled');
                if (uScope.isThisImageValid() == true) {
                    var thisImg = uScope.getThisImage();
                    if (thisImg.rasterScan != undefined) {
                        thisImg.rasterScan.resetHeatMapState();
                        if (thisImg.rasterScan.parmAction('get', _constants.eRASTERPARMS.MODE) == 'Manual') {
                            self.pause(); // closing panel in manual mode forces a raster pause
                        }
                    }
                }
            },
            focus: function focus(event, ui) {
                //requires a click // doing this for debug when open dlg at b4 image open
                configure_();
            }
        });

        jProgressBar = $('#' + _defines2.default.RPRASTERBAR).find('div');

        // add a radio buttonset to select the sequence style - buttonset doesn't work until after the dialog is associated with the panel
        var str = '<div id=' + _defines2.default.idRSSTYLEDIV + '>' + '<label id="us_piecescanL" title="Scan each tissue piece" class ="' + _defines2.default.clsSEQUENCESTYLE + '"><input type="radio" id="us_piecescan" name="radio" Value =' + _defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES + '></label>' + '<label id="us_tissuescanL" title="Scan all tissue area" class ="' + _defines2.default.clsSEQUENCESTYLE + '"><input type="radio" id="us_tissuescan" name="radio" Value =' + _defines2.default.eSEQUENCESTYLES.ALLTISSUE + '></label>' + '<label id="us_slidescanL" title="Scan whole slide area"  class ="' + _defines2.default.clsSEQUENCESTYLE + '"><input type="radio" id="us_slidescan"  name="radio"  Value =' + _defines2.default.eSEQUENCESTYLES.WHOLESLIDE + '></label>' + '</div>';
        jPanel.append($(str));
        $('#' + _defines2.default.idRSSTYLEDIV).buttonset(); // convert the radio button look to a buttonset

        self.position(); // position the panel
        bindEvents_(); // add event handlers
        configure_(); // initialize for the current image
    };
    //............................................ bindEvents_() local
    // bindEvents_ - This function adds the raster scan panel event handlers.
    //
    //    Note that an exception is made here and the namespace is not an image's namespace.

    var bindEvents_ = function bindEvents_() {
        var namespace = '.raster';

        tbOpenIcon = $('<a/>', {
            'id': _defines2.default.TBRASTEROPEN,
            'class': _defines2.default.clsTBBUTTON + ' ' + _defines2.default.TBRASTEROPEN + '-e',
            'title': 'Open the raster scan tool'
        });
        uScope.topToolbar.addButton(tbOpenIcon);

        tbOpenIcon.on('click', function () {
            show(!isDialogVisible);
            return false;
        });

        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPSTART, function (e) {
            if (uScope.isThisImageValid()) {
                var thisImg = uScope.getThisImage();
                if (thisImg && thisImg.rasterScan) {
                    $('#' + _defines2.default.RPSTART).addClass(_defines2.default.RPPAUSE).removeClass(_defines2.default.RPSTART); // change start btn to pause
                    $('#' + _defines2.default.RPSTART).attr('title', 'Stop/Pause Raster Scan'); // and update pause tooltop

                    if (thisImg.rasterScan.parmAction('get', _constants.eRASTERPARMS.MODE) == 'Automatic') {
                        // if raster scan mode is automatic,
                        $('#' + _defines2.default.RPSLOW).addClass(_defines2.default.RPSLOW).removeClass(_defines2.default.RPSLOW + '-d'); // enable faster/slower btns
                        $('#' + _defines2.default.RPFAST).addClass(_defines2.default.RPFAST).removeClass(_defines2.default.RPFAST + '-d');
                        $('#' + _defines2.default.RPBACKUP).addClass(_defines2.default.RPBACKUP + '-d').removeClass(_defines2.default.RPBACKUP); // disable backup during raster
                    } else {
                        $('#' + _defines2.default.RPBACKUP).addClass(_defines2.default.RPBACKUP).removeClass(_defines2.default.RPBACKUP + '-d'); // enable backup during raster mode manual
                    }
                    //todo: how to get the above icons to change right away??? preload images? (tissue segmentation delay is an issue)
                    thisImg.rasterScan.start();
                }
            }
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPPAUSE, function (e) {
            if (uScope.isThisImageValid()) {
                var thisImg = uScope.getThisImage();

                $('#' + _defines2.default.RPSTART).addClass(_defines2.default.RPSTART).removeClass(_defines2.default.RPPAUSE); // change pause btn to start
                $('#' + _defines2.default.RPSTART).attr('title', 'Start/Resume Raster Scan'); // and update start tooltop
                $('#' + _defines2.default.RPSLOW).addClass(_defines2.default.RPSLOW + '-d').removeClass(_defines2.default.RPSLOW); // disable faster/slower btns
                $('#' + _defines2.default.RPFAST).addClass(_defines2.default.RPFAST + '-d').removeClass(_defines2.default.RPFAST);
                $('#' + _defines2.default.RPBACKUP).addClass(_defines2.default.RPBACKUP).removeClass(_defines2.default.RPBACKUP + '-d'); //enable backup during pause

                thisImg.rasterScan.stop();
            }
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPBACKUP, function (e) {
            if (uScope.isThisImageValid()) {
                var thisImg = uScope.getThisImage();
                thisImg.rasterScan.progressReset('backup'); //todo: it might be better if restart could be signalled differenly and this fn local
                $('#' + _defines2.default.RPSTART).attr('title', 'Start Raster Scan');
                jProgressBar.width('0%');
            }
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPSLOW, function (e) {
            if (uScope.isThisImageValid()) {
                var thisImg = uScope.getThisImage();
                thisImg.rasterScan.parmAction('set', _constants.eRASTERPARMS.SPEEDFACTOR, 'slower');
            }
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPFAST, function (e) {
            if (uScope.isThisImageValid()) {
                var thisImg = uScope.getThisImage();
                thisImg.rasterScan.parmAction('set', _constants.eRASTERPARMS.SPEEDFACTOR, 'faster');
            }
        });
        $(_defines2.default.idHashROOT).on(_defines2.default.evRASTERPROGRESS + namespace, function (e, parms) {
            jProgressBar.width(parms.progressPct + '%');
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.clsSEQUENCESTYLE, function (e) {
            var input = this.children[0]; // 'this' is the label that encloses the input
            if (input.checked == true) return; // if already checked, do nothing ( getting 2 clicks for every 1)
            $(input).checked = true; // because of how the images are on the radio btns, do this myself

            $('.' + _defines2.default.clsSEQUENCESTYLE).removeClass(_defines2.default.clsRSSTYLESEL); // remove selected state from other button
            $(this).addClass(_defines2.default.clsRSSTYLESEL); // add selected state to this button

            var value = $(input).val(); // the selected raster sequence style

            var thisImg = uScope.getThisImage();
            if (thisImg && thisImg.rasterScan) // inform the raster object of the selected sequence style
                thisImg.rasterScan.parmAction('set', _constants.eRASTERPARMS.SEQUENCESTYLE, +value);
        });
        $(_defines2.default.idHashROOT).on('click' + namespace, '.' + _defines2.default.RPSETTINGS, function (e) {
            (0, _toolbar.setIconState)($('#' + _defines2.default.RPSETTINGS), _defines2.default.RPSETTINGS, 'active');
            settings_();
        });

        uScope.events.on('uscope:image:close', function () {
            self.pause();
        });
    };
    //............................................ position() public
    //    position - This function positions the raster panel to the right of the zoom control.
    //        Note that it assume the zoom control has room to its right ... instead cOverLayout should be updated to handle this.
    var lastPosition_ = void 0;
    self.position = function () {
        if (!self.isOpen()) {
            return;
        }
        var panelPos;
        var thisImg = uScope.getThisImage();
        var jVpDiv = thisImg ? thisImg.vpDivGet('outer') : undefined;
        var jZoomControl = jVpDiv ? jVpDiv.find('.' + _defines2.default.clsDIVZOOMCTL) : undefined;
        if (uScope.isThisImageValid() == false || jZoomControl == undefined) {
            var rootPos = $(_defines2.default.idHashROOT).offset();
            panelPos = [rootPos.left, Math.floor(rootPos.top + $(_defines2.default.idHashROOT).height() / 3)];
        } else {
            var offsetPos = jZoomControl.offset(); // returns 0,0 when zoomcontrol is hidden, e.g. rasterscan mode
            var zoomWidth = jZoomControl.width();
            if (offsetPos == null || offsetPos == undefined) offsetPos = { 'left': 0, 'top': 0 };
            if (offsetPos.left == 0 && offsetPos.top == 0 && lastPosition_ != undefined) panelPos = lastPosition_;else panelPos = [offsetPos.left + zoomWidth + _defines2.default.kOVERLAY_ELEMENT_SPACE, offsetPos.top];
        }
        lastPosition_ = panelPos;
        $('#' + _defines2.default.idRASTERPANEL).dialog({ left: panelPos[0], top: panelPos[1] });
    };

    // TODO: No work in constructor!
    init_();
}
module.exports = exports['default'];

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _blobAnalysisService = __webpack_require__(432);

var _blobAnalysisService2 = _interopRequireDefault(_blobAnalysisService);

var _rasterScanService = __webpack_require__(435);

var _rasterScanService2 = _interopRequireDefault(_rasterScanService);

var _rasterPanel = __webpack_require__(433);

var _rasterPanel2 = _interopRequireDefault(_rasterPanel);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

var _browserCompatibility = __webpack_require__(26);

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canStart = function canStart(uScope) {
    return !_browserCompatibility.env.isIOS && _browserCompatibility.env.supportsCanvas && uScope.toolbarCanAddButton('autoRaster');
};

_publicApi2.default.plugins.register({
    name: 'us:raster-scan:ui',
    extends: 'uScope',
    canStart: canStart,
    constructor: _rasterPanel2.default
});

_publicApi2.default.plugins.register({
    name: 'us:raster-scan:blob-analysis',
    extends: 'viewport',
    canStart: canStart,
    constructor: _blobAnalysisService2.default
});

_publicApi2.default.plugins.register({
    name: 'us:raster-scan:service',
    extends: 'viewport',
    dependencies: ['us:raster-scan:ui', 'us:raster-scan:blob-analysis', 'us:thumbnail', 'us:heatmap'],
    canStart: canStart,
    constructor: function constructor(uScope, viewport) {
        for (var _len = arguments.length, deps = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            deps[_key - 2] = arguments[_key];
        }

        // hack alert: using the viewport as a service locator...
        var rss = new (Function.prototype.bind.apply(_rasterScanService2.default, [null].concat([uScope, viewport], deps)))();
        viewport.rasterScan = rss;
    }
});

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RasterScanService;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _toolbar = __webpack_require__(27);

var _objects = __webpack_require__(16);

var _searchService = __webpack_require__(486);

var _events = __webpack_require__(31);

var _helpers = __webpack_require__(4);

var _constants = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//________________________________________________________________________________________________
// rasterScan.js
//    This file contains the RasterScanService object
//
//    history
//    1410xx     cperz        created
//    _______________________________________end_AIHv1/PR __________________________________________
//    140818    cperz        RasterScanService: manual mode: upon raster panel close reset run events and
//                        set panel state to stopped so manual can restart upon panel open;
//                        remove us.eNavModes.nmRegMove;
//    150318    cperz        add local log,err fns;
//
//________________________________________________________________________________________________
//    RASTER SCAN OBJECT
//________________________________________________________________________________________________
//    The raster scan object performs sequencing through an image in an automatic or manual fashion
//    at a user selected magnification and view overlap.  It automatically segements the image
//    and identifies tissue pieces in the image so that the user can sequence the image by tissue
//    piece, by all tissue or just over the whole slide.
//
//
//    Restrictions:
//        - requires HTML5 canvas support
//        - requires a thumbnail from its parent viewport object
//
//    File Dependencies:
//        - imageproc.js for cBlobAnalysis
//        - toolbar.js for cRasterPanel
//
//    Object Dependencies:
//        - created by cViewport
//        - uses objects cBlobAnalysis, a cHeatMap reference
//        - user controls of cRasterPanel
//
//    Design Description:
//    A raster object is created for each viewport. The raster panel, cRasterPanel, created for all of uScope,
//    calls into this raster object to change settings and start, pause, stop the raster sequencing.
//
//        User Specified Settings:
//            All user settings from the cRasterPanel are defined in eRASTERPARMS and controlled
//            by this.parmAction(). Any time a user changes a raster setting raster scan progress is
//            reset and scanning will start at the beginning.
//
//            Automatic Mode: The sequencing is initially started when the user presses the start button
//                on the raster panel. Each view in the image is sequenced without user interaction.
//                Sequencing can be paused with a mouse click on the view or by hitting the space bar.
//                When paused the user can pan and zoom the image at will. Once paused, to continue
//                the user must press the restart button on the raster panel. Sequencing will pick up
//                where it left off.
//            Manual Mode: The sequencing is initially started when the user presses the start button
//                on the raster panel. Each view in the image is sequenced when the user hits the space bar.
//                When paused the user can pan and zoom the image at will.
//            Scan Magnification: The magnification to sequence the image at.
//
//            Heat Map: The outline of the identified tissue is drawn on the thumbnail's and each sequenced
//                view is shaded on the heat map in the color of the scan magnfication.  Heat map drawing is
//                always enabled for raster scan, regardless of the user preference (of disabled).
//
//
//        Code Highlights:
//            load_() creates the 'raster image' by loading the image's thumbnail into a canvas element.
//                maskTissue_() segments the raster image into foreground and background pixels and performs
//                    blob analysis.  It produces the silhouette_ image of blob labels at the raster
//                    image resolution and the blobs_ object, a list of all blobs and their properties.
//                blobDraw_() is called upon to outline each valid blob on the image's thumbnail's heatmap.
//            this.start() is called from the raster panel when the user clicks start/resume
//                or by an event handler when raster scanning is paused and the space bar is hit.
//                If starting raster scan ...
//                    startSearchInit_() determines the search grid step size and dimensions 'csSearchGrid_'
//                        and creates search_, the object that sequences through the grid.
//                    buildSearchMask_() creates the searchMask_, a 2D array with dimensions csSearchGrid_.
//                        Then, in accordance with the user's selection of scan by tissue piece, all tissue
//                        or whole slide it initializes searchMask_'s contents with blob labels.
//                    Event handlers active only during raster scan are bound.
//                If resuming raster scan or starting the raster timer is started which calls on step_().
//            step_() uses the search_ object to select the next valid view grid position in the searchMask_
//                and move the view to that position.  If sequencing by tissue piece, when one blob's area
//                has been scanned it steps to the next blob.  If sequencing has completed, it stops the scan.
//            this.stop() is called from the raster panel when the user stops/pauses the scan
//                or by an event handler when raster scanning is active and the space bar is hit.
//                It halts the raster timer and unbinds the events that are only active during raster scan.
//
//        Coordinate System:
//            cRaster operates with left,top is 0,0; positive x to the right; positive y down
//
// Improvements:
//    - store/restore user prefs
//    - add default vars and assign to vars and use in parmDefault
//    - instead of speedFactor just increase or decrease the timer interval and store/restore timer interval

function RasterScanService(uScope, viewport, rasterPanel, blobAnalysis, thumbnail, heatmap) {
    var self = this;
    var isLoaded = false; // raster thumb image has been loaded
    var blobDrawTypes = { bbox: false, outline: true }; // blob hightlight options on image thumbnail

    var namespace_ = viewport.eventNameSpaceGet();
    var saveHeatMapState_ = _defines2.default.ENABLEHEATMAP;

    //............................................ internal use
    var search_; // search object - sequences through the grid in a specified pattern
    var csSearchGrid_ = new _objects.Size(); // granularity of views over image a the search zoom
    var cpStepSizePx_ = new _objects.Point(); // relative view move in pixels

    var searchMask_; // view sequencing 2D array, dimensioned as csSearchGrid_ with valid blobs labeled > 0 {1,2,...}
    var maskName_; // one of the us.strSEQUENCESTYLES, name of actually implemented sequence style mask
    var maskType_; // one of the us.eSEQUENCESTYLES, type of actually implemented sequence style mask

    var maskValidCount_ = 0; // total number of valid (to be scanned) grid cells in the mask
    var viewCount_ = 0; // running number of valid grid cells scanned
    var progressPct_ = 0;
    var viewResolveCount_ = 0; // count number of times step_() is entered but view not resolved for the prior request

    var blobs_; // array of found blobs // blobs_[.] = label number, area, bounding box, valid, dimensions, ...  of each blob
    var blobValidCount_ = -1; // number of valid blobs in blobs_
    var blobLabel_ = -1; // currently scanning blob label
    var blobIdx_ = -1; // currently scanning index to blobs_

    var rasterZoom_ = 1.; // raster zoom at the start of raster scan
    var csStartVPDims_ = new _objects.Size(0, 0); // view dimensions at the start of raster scan
    var cpStartGridCoord_ = new _objects.Point(0, 0); // initial raster position on search grid, changes depending upon scan pattern and if resuming scan
    var csImageDims_ = new _objects.Size(); // the image dimensions at the scan zoom

    var cpCurCoords_ = new _objects.Point(0, 0); // view position image position (zoom coords)
    var cpResumeGridCoord_ = new _objects.Point(0, 0); // previous raster position on search grid

    var timerId_ = -1; // the rasterScan timer id
    var timerInterval_ = 750; // rasterScan timer interval in milliseconds

    var rasterSpecs = { //
        'thumbScale': 0.25, // scale of raster thumbnail wrt file thumbnail
        'smallBlobArea': 3, // min area threshold on raster thumbnail blob
        'minBlobDim': 3 // minimum width or height of a raster thumbnail blob
    };

    var bSegStatus_ = false; // segmentation status (false means not performed, not valid)
    var pImageCanvas;
    var pImageContext;
    var csRasterImage = new _objects.Size(0, 0); // raster image size
    var rasterImageZoom_; // raster image zoom wrt image base level

    var silhouette_; // image of blob labels at the raster image resolution {0:background, >1 blob}
    var backColor_ = 255; // blob analysis binary fore|back ground convention
    var foreColor_ = 0; // note that these must coincide with blob extraction fns

    var bindRunEventsState_ = false; // to insure events are not bound multiple times
    //............................................ construct_ local
    var construct_ = function construct_() {
        var mag = self.parmAction('default', _constants.eRASTERPARMS.MAG); //get the default magnification
        self.parmAction('set', _constants.eRASTERPARMS.MAG, mag); // initialize all things dependent upon rasterMag_

        load_();
    };
    //............................................ user defined parameters
    var rasterMode_ = 'Automatic'; // raster mode {Manual, Automatic}
    var rasterMag_ = 4; // mag[nification]
    var sequenceStyle_ = _defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES; //

    var speedFactor_ = 100; // speedFactor_ as a percentage of timerInterval_
    var overlapPct_ = 80; // overlap percent

    var patternList = []; // the raster pattern choices
    patternList.push({ name: 'Horizontal', num: _searchService.SEARCH_PATTERN.SNAKE_RIGHT_DOWN });
    patternList.push({ name: 'Vertical', num: _searchService.SEARCH_PATTERN.SNAKE_DOWN_RIGHT });

    var searchPattern_ = _searchService.SEARCH_PATTERN.SNAKE_RIGHT_DOWN;
    var searchPatternName_ = 'Raster Right';

    var bfThresh_ = 200,
        flThresh_ = 20;
    var contentPct_ = 15; //todo: a) is this used?  b)maybe this needs to be zoom dependent... bigger area maybe more sensitive? 4x may have a small amout of content

    //............................................ parmAction() public
    //    parmAction - This function is the interface to set, get, toggle, default user specified settings.
    //        input parameters:
    //            action:        intented action {"set","get","toggle", "default"}
    //            parm:        one of the eRASTERPARMS
    //            val:        value (set action only)
    //
    self.parmAction = function (action, parm, val) {
        var parmSet = function parmSet(parm, val) {
            switch (parm) {
                case _constants.eRASTERPARMS.MODE:
                    rasterMode_ = val == 'Automatic' ? 'Automatic' : 'Manual';
                    self.progressReset('raster mode change'); // reset so paused raster will restart from the beginning
                    return rasterMode_;
                    break;
                case _constants.eRASTERPARMS.MAG:
                    rasterMag_ = val; //tood: sanity check the value
                    rasterZoom_ = viewport.convertToZoom(rasterMag_); // initialize the scan zoom
                    csImageDims_ = viewport.getImageDimsAtZoom(rasterZoom_); // initialize the image dims at scan zoom
                    self.progressReset('raster magnification change'); // reset so paused raster will restart from the beginning
                    //todo: recompute grid?
                    return rasterMag_;
                    break;
                case _constants.eRASTERPARMS.OVERLAPPCT:
                    if (val < 5) overlapPct_ = 5;else if (val > 99) overlapPct_ = 100;else overlapPct_ = parseInt(val);
                    self.progressReset('raster overlap change'); // reset so paused raster will restart from the beginning
                    //todo: recompute grid?
                    return overlapPct_;
                    break;
                case _constants.eRASTERPARMS.PATTERNNAME:
                    for (var i = 0; i < patternList.length; i++) {
                        // insure a valid pattern number is given
                        if (val == patternList[i].name) {
                            searchPattern_ = patternList[i].num;
                            searchPatternName_ = patternList[i].name;
                            break;
                        }
                    }
                    self.progressReset('raster pattern change'); // reset so paused raster will restart from the beginning
                    return searchPatternName_; // return the current pattern number
                    break;
                case _constants.eRASTERPARMS.PATTERNNUMBER:
                    // nop
                    break;
                case _constants.eRASTERPARMS.PATTERNLIST:
                    // nop
                    break;
                case _constants.eRASTERPARMS.PIXELTHRESH:
                    if (isBrightField == true) bfThresh_ = val;else flThresh_ = val;
                    self.progressReset('raster threshold change'); // reset so paused raster will restart from the beginning
                    return parmGet(_constants.eRASTERPARMS.PIXELTHRESH);
                    break;
                case _constants.eRASTERPARMS.CONTENTPCT:
                    contentPct_ = val; //todo: sanity check this 3-55 currently from gui
                    self.progressReset('raster content pct change'); // reset so paused raster will restart from the beginning
                    //todo: recompute grid?
                    return contentPct_;
                    break;
                case _constants.eRASTERPARMS.SPEEDFACTOR:
                    if (val == 'faster') speedFactor_ = Math.max(speedFactor_ - 10, 10); // faster means smaller interval
                    else speedFactor_ = Math.min(speedFactor_ + 10, 400); // slower means larger interval

                    if (rasterMode_ == 'Automatic' && timerId_ != -1) {
                        // if autorastering in progress
                        clearInterval(timerId_); // stop the rasterScan timer

                        var interval = timerInterval_ * (speedFactor_ / 100); // and restart the rasterScan at the new timer interval
                        timerId_ = setInterval(step_, interval);
                    }
                    break;
                case _constants.eRASTERPARMS.SEQUENCESTYLE:
                    if (val >= _defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES && val <= _defines2.default.eSEQUENCESTYLES.WHOLESLIDE) {
                        sequenceStyle_ = +val;
                        self.progressReset('raster segmentation change to ' + _defines2.default.strSEQUENCESTYLES[val]); // reset so paused raster will restart from the beginning
                    }
                    break;
                default:
                    break;
            }
        };
        var parmGet = function parmGet(parm) {
            switch (parm) {
                case _constants.eRASTERPARMS.MODE:
                    return rasterMode_;
                    break;
                case _constants.eRASTERPARMS.MAG:
                    return rasterMag_;
                    break;
                case _constants.eRASTERPARMS.OVERLAPPCT:
                    return overlapPct_;
                    break;
                case _constants.eRASTERPARMS.PATTERNNAME:
                    return searchPatternName_;
                    break;
                case _constants.eRASTERPARMS.PATTERNNUMBER:
                    return searchPattern_;
                    break;
                case _constants.eRASTERPARMS.PATTERNLIST:
                    return patternList; // returns a reference!
                    break;
                case _constants.eRASTERPARMS.PIXELTHRESH:
                    return isBrightField == true ? bfThresh_ : flThresh_;
                    break;
                case _constants.eRASTERPARMS.CONTENTPCT:
                    return contentPct_;
                    break;
                case _constants.eRASTERPARMS.SPEEDFACTOR:
                    return speedFactor_;
                    break;
                case _constants.eRASTERPARMS.SEQUENCESTYLE:
                    return sequenceStyle_;
                    break;
                default:
                    break;
            }
        };
        var parmDefault = function parmDefault(parm) {
            switch (parm) {
                case _constants.eRASTERPARMS.MODE:
                    return parmSet(_constants.eRASTERPARMS.MODE, 'Automatic');
                    break;
                case _constants.eRASTERPARMS.MAG:
                    return parmSet(_constants.eRASTERPARMS.MAG, 4);
                    break;
                case _constants.eRASTERPARMS.OVERLAPPCT:
                    return parmSet(_constants.eRASTERPARMS.OVERLAPPCT, 80);
                    break;
                case _constants.eRASTERPARMS.PATTERNNAME:
                    return parmSet(_constants.eRASTERPARMS.PATTERNNAME, patternList[0].name);
                    break;
                case _constants.eRASTERPARMS.PATTERNNUMBER:
                    //nop
                    break;
                case _constants.eRASTERPARMS.PATTERNLIST:
                    //nop
                    break;
                case _constants.eRASTERPARMS.PIXELTHRESH:
                    bfThresh_ = 200;
                    flThresh_ = 20; //note! defaulting both bf and fl
                    self.progressReset('raster threshold change'); // reset so paused raster will restart from the beginning
                    return parmGet(_constants.eRASTERPARMS.PIXELTHRESH);
                    break;
                case _constants.eRASTERPARMS.CONTENTPCT:
                    return parmSet(_constants.eRASTERPARMS.CONTENTPCT, 15);
                    break;
                case _constants.eRASTERPARMS.SPEEDFACTOR:
                    return speedFactor_ = 100;
                    break;
                case _constants.eRASTERPARMS.SEQUENCESTYLE:
                    return parmSet(_constants.eRASTERPARMS.BYTISSUEPIECES, _defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES);
                    break;
                default:
                    break;
            }
        };
        var parmToggle = function parmToggle(parm) {
            switch (parm) {
                case _constants.eRASTERPARMS.MODE:
                    return rasterMode_ == 'Automatic' ? parmSet(_constants.eRASTERPARMS.MODE, 'Manual') : parmSet(_constants.eRASTERPARMS.MODE, 'Automatic');
                    break;
                default:
                    break;
            }
        };
        //..................................................
        if (action == 'set') return parmSet(parm, val);else if (action == 'get') return parmGet(parm);else if (action == 'default') return parmDefault(parm);else if (action == 'toggle') return parmToggle(parm);

        return undefined;
    };
    //............................................ progressReset() public
    // progressReset occurs when user prefs change, start, start over
    self.progressReset = function () {
        if (progressGet_() > 0) {
            stop_();
        }

        cpStartGridCoord_.set(0, 0); // raster SNAKE_RIGHT_DOWN and SNAKE_RIGHT_DOWN start position on grid
        viewCount_ = 0;
        blobIdx_ = -1;
        blobLabel_ = -1;

        progressPct_ = 0;
        progressUpdate_();

        heatmap.erase();

        bSegStatus_ = maskTissue_(); // segment the image at resterImage resolution (foreground / background);
        blobDraw_(); // draw the segmentation results on the thumbnail if the raster panel is open
    };
    //............................................ progressUpdate_() local
    var progressUpdate_ = function progressUpdate_() {
        thumbnail.viewFinderMove('raster'); // update the thumbnail viewfinder right now

        progressPct_ = progressGet_();
        (0, _events.triggerUScopeEvent)(_defines2.default.evRASTERPROGRESS, { progressPct: progressPct_ }); // fire event to broadcast rasterScan progress
    };
    //............................................ progressGet_() local
    var progressGet_ = function progressGet_() {
        progressPct_ = maskValidCount_ > 0 ? progressPct_ = parseInt(100 * viewCount_ / maskValidCount_) : 0; //
        return progressPct_;
    };

    //............................................ // misc
    var isBrightField = viewport.getCaptureType() != _defines2.default.eAICCaptureType.aic_i_FL;
    var cpPrevVPViewLT_ = new _objects.Point(0, 0); // debug vars

    //............................................ onPanelOpen() public
    // This function is called when the raster panel is opened
    self.onPanelOpen = function () {
        saveHeatMapState_ = uScope.prefGet(_defines2.default.CVSHEATMAP);
        if (saveHeatMapState_ == false) uScope.prefSet(_defines2.default.CVSHEATMAP, true);

        blobDraw_(); // draw the segmentation results on the thumbnail if the raster panel is open
    };
    //............................................ resetHeatMapState() public
    // This function is called when the raster panel is closed and when the raster scan mode is halted
    // to insure that the heat map visibility is returned to its original user preference prior to raster scanning.
    self.resetHeatMapState = function () {
        // if the raster panel is closed AND no longer raster scanning hide the heatmap if the original user pref was so
        if (rasterPanel.isOpen() == false && viewport.navModeGet() == _defines2.default.eNavModes.nmNone) {
            if (saveHeatMapState_ == false) uScope.prefSet(_defines2.default.CVSHEATMAP, false);
        }
    };
    //............................................ bindEvents() local
    var bindEvents = function bindEvents() {
        $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace_, function (e, parms) {
            // image select event
            if (viewport.getImageIdx() == uScope.getSelImageIdx()) {
                // .....if this image is the selected image
                if (rasterPanel.isOpen() == true) {
                    // if the rasterscan panel is open
                    rasterPanel.position(); // then reposition the panel onto this image
                    rasterPanel.pause(); // pause raster scan
                }
            } else {
                // ..... else this image is NOT the selected image
                if (viewport.navModeGet() == _defines2.default.eNavModes.nmRasterScan) {
                    // if in rasterScan mode,
                    rasterPanel.pause(); // pause raster scan
                }
            }
        });

        viewport.events.on('viewport:resize', self.progressReset);

        // Stop raster scan when readOnly attribute for a plugin (VP) is true.
        viewport.events.on('state-readonly:change', function (isReadOnly) {
            if (isReadOnly) {
                self.stop();
            }
        });

        // insure heatmap state is reset when halting raster scan
        viewport.events.on('viewport:stop-navigation', function (navMode) {
            if (navMode === _defines2.default.eNavModes.nmRasterScan) {
                self.resetHeatMapState();
                return true;
            }
        });
    };

    //............................................ bindRunEventsOn_() local
    // This function binds the space bar event to pause/resume scanning.
    //    The event is unbound when the raster panel is closed or the scan fully completes
    var bindRunEventsOn_ = function bindRunEventsOn_() {
        if (bindRunEventsState_ == true) return;

        $(_defines2.default.idHashROOT).on(_defines2.default.evSPACEBAR + namespace_, function (e, parms) {
            if (rasterMode_ == 'Automatic') {
                if (timerId_ != -1) {
                    stop_('spacebar stop'); // if rasterScan is running, stop
                } else {
                    start_(); // if rasterScan is not running, start
                }
            } else {
                step_();
            }
            return false;
        });
        bindRunEventsState_ = true;
    };
    //............................................ bindRunEventsOff_() local
    var bindRunEventsOff_ = function bindRunEventsOff_() {
        $(_defines2.default.idHashROOT).off(_defines2.default.evSPACEBAR + namespace_);
        bindRunEventsState_ = false;
    };
    //............................................ start_ local
    var start_ = function start_() {
        rasterPanel.start();
    };
    //............................................ start() public
    //    This function starts/resumes rasterScan scanning.
    self.start = function () {
        if (viewport.navModeGet() === _defines2.default.eNavModes.nmRasterScan) {
            return;
        }

        viewport.navModeSwitch(_defines2.default.eNavModes.nmRasterScan); // zooming changed nav mode to none, so change it back

        var bStart = progressPct_ == 0 || progressPct_ > 98; // are we starting at the beginning or resuming?

        // if the view has been resized since the last rasterScan start or it has been zoomed and we are not told to resume the raster,
        // reset the start of raster position
        var csVPDivDimsRightNow = viewport.vpDivDimsGet(); // if a resize or mag change has occurred, stop rasterScan
        if (csVPDivDimsRightNow.w != csStartVPDims_.w || csVPDivDimsRightNow.h != csStartVPDims_.h) {
            bStart = true;
            if (progressPct_ > 0) {
                // ('view resize change occured: must restart raster from the beginning.'); // eslint-disable-line no-undef
            }
        }

        if (bStart == true) {
            // start new grid......................
            self.progressReset('start');
            heatmapStyle(); // set the thumbnail heat map style for raster scanning
            if (startSearchInit_(csVPDivDimsRightNow) == false) {
                // compute the step size and grid dimensions 'csSearchGrid_'
                stop_('Search initialization failed'); // on error, auto halt
                return;
            }

            buildSearchMask_(); // produce the searchMask_ of dimensions 'csSearchGrid_' and update blobs_ array
            if (blobValidCount_ < 1) {
                stop_('Blob mask creation failed'); // if there's no blobs, don't start
                return;
            }

            blobLabel_ = blobNextValid_(); // perform raster sequence one blob at a time, get first valid blob
            if (blobLabel_ < 0) {
                stop_('Blob label invalid'); // if there's no blobs, don't start
                return;
            }

            bindRunEventsOn_(); // active raster run events
        } else {
            // resume on current grid .............
            heatmapStyle(); // set the thumbnail heat map style for raster scanning
            bindRunEventsOn_(); // active raster run events

            // resume begins at the prior view position
        }

        if (rasterZoom_ != viewport.getViewZoom()) {
            // set the view zoom to the original raster scan zoom
            viewport.zoomAbsolute(rasterZoom_);
        }

        viewport.navModeSwitch(_defines2.default.eNavModes.nmRasterScan); // zooming changed nav mode to none, so change it back
        viewport.focus(); // set focus to this viewport so spacebar event can be captured

        if (rasterMode_ == 'Automatic') {
            var interval = timerInterval_ * (speedFactor_ / 100);
            timerId_ = setInterval(step_, interval); // and start the rasterScan sequence
        }
        //..................................................
        // closure functions
        // This function sets the heatmap style for raster scan.
        function heatmapStyle() {
            if (heatmap) {
                var alpha = Math.min(0.3, overlapPct_ / 100);
                heatmap.alphaSet(alpha);
                var color = _defines2.default.objectiveColor(rasterMag_);
                heatmap.fillColorSet(color);
                heatmap.strokeColorSet(color);
            }
        }
    };

    //............................................ stop_() local
    var stop_ = function stop_() {
        // internal stop to simulate user click pause button
        rasterPanel.pause(); // pause raster scan
    };
    //............................................ stop() public
    //    This function turns off/pauses rasterScan.
    //    Note that the spacebar event is not unbound until the raster panel is closed........

    //toconsider: pause verse stop where stop would unbind the spacebar
    //toconsider: could report state of scan and determine if halted mid-scan

    self.stop = function () {
        viewport.navModeHalt(); // halt raster scan navigation mode

        clearInterval(timerId_); // stop the rasterScan timer
        timerId_ = -1; // and reset its value

        progressUpdate_(); // insure the user sees the current progress

        // if manual scan or if automatic scan is complete, remove the raster run events
        if (rasterMode_ == 'Manual' || rasterMode_ == 'Automatic' && progressPct_ > 99) bindRunEventsOff_();

        if (thumbnail.heatMap) thumbnail.heatMap.contextDefault(); // reset heatmap context so any user navigation is drawn normally
    };
    //............................................ step_() local
    //    This function moves the view one grid position
    var step_ = function step_() {
        // ....................... stop if if no longer in raster mode
        if (viewport.navModeGet() != _defines2.default.eNavModes.nmRasterScan) {
            // ('step: navMode:' + viewport.navModeGetStr() + ' expecting raster mode, stopping'); // eslint-disable-line no-undef
            stop_(' navMode:' + viewport.navModeGetStr() + ' expecting raster mode, stopping');
            return;
        }

        // This used to wait till all tiles in the viewport loaded (or a preset timeout was hit) before moving on.
        // TODO: Restore if necessary.

        // ....................... stop if a resize or mag change has occurred
        var iterator;
        var csVPDivDimsRightNow = viewport.vpDivDimsGet();
        if (csVPDivDimsRightNow.w != csStartVPDims_.w || csVPDivDimsRightNow.h != csStartVPDims_.h || viewport.getViewZoom() != rasterZoom_) {
            stop_('view resized or zoomed'); // auto halt
            return;
        }

        // .......................start or resume rastering
        do {
            // loop until a valid mask cell is found but halt rasterScan if at the end of the search
            iterator = search_.next(); // get the next grid coords in the sequence
            if (!iterator) {
                // 1 check: is this next grid position valid to scan?
                blobLabel_ = blobNextValid_(); // 1 no: then move on to the next blob to scan

                if (blobLabel_ >= 0) {
                    // 2 check: is the new blob label valid? if so, restart scan for next blob
                    cpStartGridCoord_.set(0, 0); // 2 yes:  the new blob label is valid
                    // so, create the search object that will sequence the raster for the next blob
                    search_ = new _searchService.SearchService(cpStartGridCoord_, csSearchGrid_, searchPattern_);
                    iterator = search_.next(); // and get started
                } else {
                    // 2 no: the new blob label is not valid
                    self.stop();
                    stop_('scan finished'); // change  then auto halt when scan is complete
                    return;
                }
            } // check that the mask indicates a valid scan position, if not then loop
        } while (searchMask_[iterator.x][iterator.y] != blobLabel_);

        cpCurCoords_.x = iterator.x * cpStepSizePx_.x * rasterZoom_; // compute the view position in zoom coords
        cpCurCoords_.y = iterator.y * cpStepSizePx_.y * rasterZoom_;

        viewport.moveAbsolute(cpCurCoords_.x, cpCurCoords_.y, { animate: true });
        viewResolveCount_ = 0;

        cpResumeGridCoord_.set(iterator.x, iterator.y); // save the last grid position (for resume)

        progressUpdate_();
        viewCount_++; // update the number of grid cells scanned
    };
    //............................................ buildSearchMask_() public
    //    buildSearchMask_ -This function builds the scan mask 'searchMask_' which is a grid of views labeled
    //    with blob numbers used to sequence the raster scan through the image.  It also updates the blobs_
    //    array and blobValidCount_ which define the labeled tissue pieces.
    //
    //    It will first try to initialize the mask for the sequence style the user selected
    //    but if that does not succeed it will gracefully degrade to a sequence style it can peform.
    //

    var buildSearchMask_ = function buildSearchMask_() {
        maskType_ = sequenceStyle_; // maskType_ is the actually implmented sequence style

        //cp: can this be inside of maskTissueToGrid_ and maskAllTissueToGrid_

        if (!bSegStatus_) {
            // if tissue mask was not created on load_()
            maskType_ = _defines2.default.eSEQUENCESTYLES.WHOLESLIDE; // then force a whole slide scan
        }

        // gracefully degrade ....
        if (maskType_ == _defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES) {
            // if desire is to raster scan each piece of tissue one at a time
            if (!maskTissueToGrid_()) {
                // map the high resolution tissue silhouette to the grid in searchMask_
                maskType_ = _defines2.default.eSEQUENCESTYLES.WHOLESLIDE; // if failed, step down to whole slide
            }
        }
        if (maskType_ == _defines2.default.eSEQUENCESTYLES.WHOLESLIDE) {
            // if desire or fallback is to raster scan the whole slide
            maskEverythingToGrid_();
        }

        // This can be undefined if the user changes mask type before starting a scan.
        // TODO: This was added as a bugfix; it's logic wasn't validated. Additional work may need to be done.
        if (!searchMask_) {
            searchMask_ = (0, _helpers.array2DCreate)(csSearchGrid_.w, csSearchGrid_.h);
        }

        return maskType_;
    };
    //............................................ startSearchInit_() local
    //    startSearchInit_ - This function initializes the search by setting up the search grid step size, dimensions, etc.
    //    Returns true if successful, false otherwise.
    var startSearchInit_ = function startSearchInit_(csVPDivDimsRightNow) {

        csStartVPDims_.set(csVPDivDimsRightNow.w, csVPDivDimsRightNow.h); // initialize the vp div dims at start of raster

        if (searchPattern_ == _searchService.SEARCH_PATTERN.SNAKE_RIGHT_DOWN) {
            // raster right_down has more overlap in x than in y
            cpStepSizePx_.set(parseInt((100. - overlapPct_) / 100 * csVPDivDimsRightNow.w), parseInt(overlapPct_ / 100 * csVPDivDimsRightNow.h));
        } else if (searchPattern_ == _searchService.SEARCH_PATTERN.SNAKE_DOWN_RIGHT) {
            cpStepSizePx_.set(parseInt(overlapPct_ / 100 * csVPDivDimsRightNow.w), parseInt((100. - overlapPct_) / 100 * csVPDivDimsRightNow.h));
        } else {
            // ('unknown search pattern'); // eslint-disable-line no-undef
            (0, _toolbar.genericMessage)('Search pattern is not recognized', 'AutoRaster');
            return false;
        }

        // now determine the search grid dimensions
        //    The search grid dimensions is defined by the number of views of size cpStepSizePx_ necessary to cover the image at the given scan zoom.
        var x = 0,
            xStep = cpStepSizePx_.x; // compute the number of views in the X-direction
        while (x * xStep + csStartVPDims_.w <= csImageDims_.w) {
            x++;
        }
        csSearchGrid_.w = x + 1;

        var y = 0,
            yStep = cpStepSizePx_.y; // compute the number of views in the Y-direction
        while (y * yStep + csStartVPDims_.h <= csImageDims_.h) {
            y++;
        }
        csSearchGrid_.h = y + 1;

        if (csSearchGrid_.w < 2 && csSearchGrid_.h < 2) {
            // sanity check
            // ('startSearchInit_: search grid is too small: ' + csSearchGrid_.w + 'x' + csSearchGrid_.h); // eslint-disable-line no-undef
            (0, _toolbar.genericMessage)('Search area at raster magnification ' + rasterMag_ + 'X is too small', 'AutoRaster');
            return false;
        }

        // create the search object that will sequence the raster
        search_ = new _searchService.SearchService(cpStartGridCoord_, csSearchGrid_, searchPattern_);

        return true;
    };
    //............................................ maskTissueToGrid_() local
    //    This function maps the high resolution silhouette_ 2d array of blob labels to the view-step (aka grid)
    //    resolution of searchMask_. It creates the searchMask_ grid with each tissue piece identified as a unique blob.
    //    It also initializes the blobs_ array and blobValidCount_.
    //    It returns true if successful and false otherwise.

    var maskTissueToGrid_ = function maskTissueToGrid_() {
        if (silhouette_ == undefined) {
            // ('maskTissueToGrid_: requires the mask to be prepared'); // eslint-disable-line no-undef
            return false;
        }

        maskName_ = _defines2.default.strSEQUENCESTYLES[_defines2.default.eSEQUENCESTYLES.BYTISSUEPIECES];
        maskValidCount_ = 0;

        searchMask_ = (0, _helpers.array2DCreate)(csSearchGrid_.w, csSearchGrid_.h); // create the blob mask array at the grid dimensions
        array2DSet(searchMask_, searchMask_.width, searchMask_.height, 0); // clear it to zero

        var csImgDims = viewport.getImageDims();
        var gridScaleX = csImgDims.w / searchMask_.width; // the scale between image base coords and the searchMask_
        var gridScaleY = csImgDims.h / searchMask_.height;

        var xbase = 0,
            ybase = 0; // the image base coord of a silhouette cell
        var baseStep = 1. / rasterImageZoom_; //
        for (var y = 0, ylen = silhouette_.height; y < ylen; y++) {
            // step
            xbase = 0;
            var gridY = parseInt(ybase / gridScaleY);

            for (var x = 0, xlen = silhouette_.width; x < xlen; x++) {
                var gridX = parseInt(xbase / gridScaleX); // cp-can probably incr this too....
                if (silhouette_[x][y] > 0) {
                    if (gridX < searchMask_.width && gridY < searchMask_.height) {
                        if (searchMask_[gridX][gridY] == 0) // increment the number of to-be-scaned grid cells
                            maskValidCount_++;
                        searchMask_[gridX][gridY] = silhouette_[x][y]; // silhouette_'s blob number moved to searchMask_
                    }
                }
                xbase += baseStep;
            }
            ybase += baseStep;
        }
        return true;
    };

    //............................................ maskAllTissueToGrid_() local
    //    This function maps the high resolution silhouette_ 2d array of blob labels to the view-step (aka grid)
    //    resolution of searchMask_. It creates the searchMask_ grid with all tissue identified as one blob.
    //    It also initializes the blobs_ array (of one foreground blob) and blobValidCount_ (to 1).
    //    It returns true if successful and false otherwise.
    //
    // NOTE: UNUSED FUNCTION!
    var maskAllTissueToGrid_ = function maskAllTissueToGrid_() {
        if (maskTissueToGrid_() == true) {
            // produces blobs_ and searchMask_ for tissue pieces
            maskName_ = _defines2.default.strSEQUENCESTYLES[_defines2.default.eSEQUENCESTYLES.ALLTISSUE];
            var label = 1; // the blob label for whole tissue raster - replaces all labels in the searchMask_
            maskValidCount_ = 0;
            for (var y = 0, height = searchMask_.height; y < height; y++) {
                for (var x = 0, width = searchMask_.width; x < width; x++) {
                    if (searchMask_[x][y] != 0) {
                        searchMask_[x][y] = label;
                        maskValidCount_++;
                    }
                }
            }
            var blobIn = new Array(maskValidCount_); // 1D array input to blob detection
            (0, _helpers.memset)(blobIn, 0, maskValidCount_, foreColor_); // set the array to foreground value
            var labelMask1D = blobAnalysis.detect(blobIn, searchMask_.width, searchMask_.height);
            blobs_ = blobAnalysis.getBlobs(labelMask1D, searchMask_.width, searchMask_.height); // blobs_[.] = label number, area and bounding boxes of each blob
            blobIntegrity_(labelMask1D); // adds blob dimensions and valid properties, combines intersecting blobs, sets valid state
            return true;
        }
        return false;
    };
    //............................................ maskEverythingToGrid_() local
    // This function creates the searchMask_ grid with all grid cells identified as one blob (the whole slide).
    //    It also initializes the blobs_ array (of one foreground blob) and blobValidCount_ (to 1).
    //    It returns true if successful and false otherwise.

    var maskEverythingToGrid_ = function maskEverythingToGrid_() {
        maskName_ = _defines2.default.strSEQUENCESTYLES[_defines2.default.eSEQUENCESTYLES.WHOLESLIDE];
        maskValidCount_ = csSearchGrid_.w * csSearchGrid_.h;

        searchMask_ = (0, _helpers.array2DCreate)(csSearchGrid_.w, csSearchGrid_.h); // create the 2D mask array
        array2DSet(searchMask_, searchMask_.width, searchMask_.height, 1); // assign entire grid to blob label 1

        var blobIn = new Array(maskValidCount_); // 1D array input to blob detection
        (0, _helpers.memset)(blobIn, 0, maskValidCount_, foreColor_); // set the array to foreground value
        var labelMask1D = blobAnalysis.detect(blobIn, searchMask_.width, searchMask_.height);
        blobs_ = blobAnalysis.getBlobs(labelMask1D, searchMask_.width, searchMask_.height); // blobs_[.] = label number, area and bounding boxes of each blob

        blobIntegrity_(labelMask1D); // adds blob dimensions and valid properties, combines intersecting blobs, sets valid state
        return true;
    };
    //............................................ maskTissue_() local
    //    maskTissue_ - This function performs blob detection on the high resolution thumbnail
    //    producing the blobs_ array listing the blobs found and their attributes and the
    //    silhouette_ 2D image of the tissue labeled by blob number.
    //
    // improvement option: add a 1 pixel border around the image for blob extraction's edge issues

    var maskTissue_ = function maskTissue_() {
        blobValidCount_ = 0;

        if (!isLoaded) {
            return false;
        }

        if (_defines2.default.DBGRASTERSCAN == true) {
            var startTime = new Date();
        }
        // threshold the raster image in the canvas and save the results in a 1D array in preparation for blob analysis
        var i, b, len;
        var foregroundCount = 0; // count the number of foreground pixels in the image
        var imgData = pImageContext.getImageData(0, 0, csRasterImage.w, csRasterImage.h); // get image data from canvas
        var blobIn = new Array(csRasterImage.w * csRasterImage.h); // create a 1D array for blob extraction to use
        if (isBrightField) {
            // is BF, green channel > threshold?
            for (i = 1, b = 0, len = csRasterImage.w * csRasterImage.h * 4; i < len; i += 4, b++) {
                //start i at 1 addresses the green channel
                if (imgData.data[i] < bfThresh_) {
                    blobIn[b] = foreColor_;
                    foregroundCount++;
                } else {
                    blobIn[b] = backColor_;
                }
            }
        } else {
            // is FL, sum of channels > threshold?
            for (i = 0, b = 0, len = csRasterImage.w * csRasterImage.h * 4; i < len; i++, b++) {
                var sum = imgData.data[i++] + imgData.data[i++] + imgData.data[i++];
                if (sum > flThresh_) {
                    blobIn[b] = foreColor_;
                    foregroundCount++;
                } else {
                    blobIn[b] = backColor_;
                }
            }
        }

        // perform blob detection: input is blobIn, output is labelMask1D (a 1D array of blob labels)
        var labelMask1D = blobAnalysis.detect(blobIn, csRasterImage.w, csRasterImage.h);
        labelMask1D.length = csRasterImage.w * csRasterImage.h;

        // get the blob list from the labelMask1D into the blobs_ object
        // blobs_[.] = label number, area and bounding boxes of each blob
        blobs_ = blobAnalysis.getBlobs(labelMask1D, csRasterImage.w, csRasterImage.h);

        // filter the blob list to remove small blobs and combine intersecting blobs, order it, add a valid property
        blobIntegrity_(labelMask1D);

        // convert the labelMask1D to the silhouette_ 2D array of labels {0:background, >1 blob}  which is at the resolution of the raster image
        silhouette_ = (0, _helpers.array2DCreate)(csRasterImage.w, csRasterImage.h); // silhouette_ is a 2D mask at raster thumb resolution containing blob labels
        for (var y = 0, s = 0, ylen = silhouette_.height; y < ylen; y++) {
            // fill the silhouette_ with the tissue label
            for (var x = 0, xlen = silhouette_.width; x < xlen; x++, s++) {
                if (labelMask1D[s] > 0) silhouette_[x][y] = labelMask1D[s];else silhouette_[x][y] = 0;
            }
        }
        return true;
    };
    //............................................ blobIntegrity_() local
    //    blobIntegrity_ - This function adds blob dimensions and valid properties,
    //    combines intersecting blobs, sets valid state, and counts the number of valid blobs.
    //    It  modifies the labels and valid flag in the blobs_ array and produces blobValidCount_.
    var blobIntegrity_ = function blobIntegrity_(labelMask1D) {

        blobValidCount_ = 0;
        var bcnt = blobs_.length;
        if (bcnt > 1) {
            // there must be more than 1 blob (1st blob is whole image)

            blobs_[0].valid = false; // blobs_[0] is alsways the whole slide so just invalidate it for raster purposes

            var swapped; // sort the blobs in ascending X order - this then defines raster scan order
            do {
                swapped = false;
                for (var b = 0; b < bcnt - 1; b++) {
                    if (blobs_[b].x1 > blobs_[b + 1].x1) {
                        var temp = blobs_[b];
                        blobs_[b] = blobs_[b + 1];
                        blobs_[b + 1] = temp;
                        swapped = true;
                    }
                }
            } while (swapped);

            for (var t = 0; t < bcnt; t++) {
                // if any blobs are fully inside another, join them
                for (var b = 0; b < bcnt; b++) {
                    if (t != b && blobs_[t].valid == true && blobs_[b].valid == true) {
                        if (blobBoxInside_(blobs_[t], blobs_[b])) {
                            if (blobs_[t].area > blobs_[b].area) {
                                replaceLabels(blobs_[b].l, blobs_[t].l); // replace all b labels with b-1
                                blobs_[b].valid = false;
                            } else {
                                replaceLabels(blobs_[t].l, blobs_[b].l); // replace all b-1 labels with b
                                blobs_[t].valid = false;
                            }
                        }
                    }
                }
            }
            var strValid = '';
            var smallBlobArea = rasterSpecs.smallBlobArea;
            var minDim = rasterSpecs.minBlobDim;
            if (smallBlobArea > 0) {
                for (var b = 0; b < bcnt; b++) {
                    // remove really small blobs, long thin blobs (coverslip edges)
                    if (blobs_[b].valid == true) {
                        var blob = blobs_[b];
                        if (blob.area > smallBlobArea && blob.width > minDim && blob.height > minDim) strValid += '\n #' + b + ' label: ' + blob.l + ' area: ' + blob.area + ',' + ' width: ' + blob.width + ',' + ' height: ' + blob.height;else {
                            blob.valid = false; // invalidate small blobs
                            replaceLabels(blob.l, 0); // replace all of its labels with 0, indicating background
                        }
                    }
                }
            }

            blobAnalysis.addBlobEdges(blobs_, labelMask1D); // add blob edge array to valid blobs

            for (var b = 0; b < bcnt; b++) {
                // count the number of valid blobs left
                if (blobs_[b].valid == true) blobValidCount_++;
            }
        }
        return blobValidCount_;

        //..................................................
        // closure functions
        // improvements:
        //    - move to imageproc.js?
        function replaceLabels(origLabel, newLabel) {
            // This function replaces a label in the labelMask1D array
            for (var i = 0, len = labelMask1D.length; i < len; i++) {
                if (labelMask1D[i] == origLabel) labelMask1D[i] = newLabel;
            }
        }

        function blobBoxInside_(blobA, blobB) {
            // This function answers the question: is blobB inside of blobA?
            return blobB.x1 > blobA.x1 && blobB.x2 < blobA.x2 && blobB.y1 > blobA.y1 && blobB.y2 < blobA.y2;
        }

        function blobBoxOverlap_(blobA, blobB) {
            // This function answers the question: do the bounding boxes of these blobs intersect?
            // On each axis, check to see if the centers of the boxes are close enough that they'll intersect.
            // If they intersect on both axes, then the boxes intersect. If they don't, then they don't.
            return Math.abs(blobA.x1 - blobB.x1) * 2 <= blobA.width + blobB.width && Math.abs(blobA.y1 - blobB.y1) * 2 <= blobA.height + blobB.height;
        }

        //.................................................
    };
    //............................................ blobDraw_() local
    // blobDraw_ - This function draws the bounding box of each valid blob found in the silhouette_ image on the heatmap.
    var blobDraw_ = function blobDraw_() {
        var blobDrawBBox_ = function blobDrawBBox_() {
            for (var b = 0, bcnt = blobs_.length; b < bcnt; b++) {
                if (blobs_[b].valid == false) continue;
                var blob = blobs_[b]; // blobs are in raster image dims

                var x1 = parseInt(blob.x1 * scale);
                var y1 = parseInt(blob.y1 * scale);
                var w = (blob.x2 - blob.x1 + 1) * scale;
                var h = (blob.y2 - blob.y1 + 1) * scale;
                heatmap.drawRect(x1, y1, w, h, 1.0, outlineColor);
            }
        };
        // This function draws the outline of each valid blob found in the silhouette_ image on the heatmap.
        var blobDrawEdges_ = function blobDrawEdges_() {
            var edgesInGrid = []; // to hold edges in thumbnail overlay dims
            for (var b = 0, bcnt = blobs_.length; b < bcnt; b++) {
                if (blobs_[b].valid == false) continue;
                var edges = blobs_[b].edges; // blobs edges are in raster image dims
                for (var e = 0, len = edges.length; e < len; e++) {
                    var x1 = parseInt(edges[e].x * scale); // convert the pixel position to thumbnail coords
                    var y1 = parseInt(edges[e].y * scale);
                    edgesInGrid.push({ x: x1, y: y1 });
                }
            }
            heatmap.drawPixels(edgesInGrid, outlineColor, true); //
        };

        if (!rasterPanel || !rasterPanel.isOpen()) // don't draw unless the user has the raster panel open
            return;
        if (blobs_ == undefined || silhouette_ == undefined || heatmap == undefined || blobValidCount_ == 0) return;

        var outlineColor = _defines2.default.objectiveColor(rasterMag_);

        var csThumb = thumbnail.dimensionsGet();
        var scale = csThumb.w / csRasterImage.w;

        if (blobDrawTypes.bbox == true) // draws the bounding box of each valid blob found in the silhouette_ image on the heatmap
            blobDrawBBox_();
        if (blobDrawTypes.outline == true) //draws the outline of each valid blob found in the silhouette_ image on the heatmap
            blobDrawEdges_();
    };
    //............................................ blobNextValid_() local
    // This function returns the next valid blob label in the blobs_ array or -1 if none are valid.
    // It maintains the local blobIdx_ and blobLabel_ vars.
    var blobNextValid_ = function blobNextValid_() {
        for (var b = blobIdx_ + 1; b < blobs_.length; b++) {
            if (blobs_[b].valid == true) {
                blobIdx_ = b;
                blobLabel_ = blobs_[b].l;
                return blobLabel_;
            }
        }
        blobIdx_ = -1;
        blobLabel_ = -1;
        return blobLabel_;
    };

    //............................................ load_() local
    //    This function loads into a canvas element a thumbnail image that will be used for segmentation.
    //
    //    toconsider:
    //        - the id approach here assumes the same image is not opened twice - fix that with a random value
    var load_ = function load_() {
        if (uScope.isThisImageIdValid(viewport.getImageId()) == false) // protect against rapid slide close/open sequence
            return // ('load_: image is not loaded'); // eslint-disable-line no-undef

        var vpclassid = _defines2.default.classFromImageId(viewport.getImageId()); // convert the imageId into a class name
        var rasterImageTagId = _defines2.default.IMGRASTER + '_' + vpclassid;

        // create the progressive image canvas tag where the raster image will reside (whole image but small like a thumbnail)
        pImageCanvas = document.createElement('canvas');
        pImageContext = pImageCanvas.getContext('2d');

        var csThumbDims = viewport.getThumbFileDims();
        var width = Math.floor(csThumbDims.w * rasterSpecs.thumbScale); // the requested thumbnail width
        var sRasterImgSrc = viewport.urlBuilder.thumb(width, 0);
        var csImgDims = viewport.getImageDims(); // compute progressive image width, height and zoom

        rasterImageZoom_ = width / csImgDims.w;

        var imageLoader = new Image();
        imageLoader.onload = function () {
            isLoaded = true;
            csRasterImage.set(imageLoader.width, imageLoader.height);

            pImageCanvas.width = csRasterImage.w; // size the canvas
            pImageCanvas.height = csRasterImage.h;

            pImageContext.drawImage(imageLoader, 0, 0, csRasterImage.w, csRasterImage.h);
            bSegStatus_ = maskTissue_(); // segment the image at rasterImage resolution (foreground / background);
            blobDraw_(); // draw the segmentation results on the thumbnail if the raster panel is open
            bindEvents();

            pImageCanvas.appendChild(imageLoader);
            // on IE11 chokes (something to do with CORS; not honestly sure what...)
        };
        imageLoader.onerror = function (e) {
            isLoaded = false;
            // ('RasterScanService - failed to load image', e); // eslint-disable-line no-undef
        };
        // Allow direct imageserver accessed raster image to use canvas.getImageData without being tainted by cross-origin rules.
        imageLoader.crossOrigin = 'anonymous';
        imageLoader.id = rasterImageTagId;
        imageLoader.src = sRasterImgSrc;
    };

    construct_();
}

function array2DSet(anArray, width, height, value) {
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < height; y++) {
            anArray[x][y] = value;
        }
    }
}
module.exports = exports['default'];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_PATTERN = undefined;
exports.SearchService = SearchService;

var _objects = __webpack_require__(16);

var _helpers = __webpack_require__(4);

//    This file contains the Search object which implements sequencing through a region in a
//            pattern of motion defined by ePattern.
//            The region coordinate system is left,top of 0,0; positive x to the right;
//            positive y down.  Hence all return points will have positive coordinates (except the
//            last, end-of-search, point).
//
//            To start search create a Search object with the starting coordinate, region and pattern
//            to sequence.  Then call Next() to get each point in succession until the search has
//            completed as indicated by an empty return value.

var SEARCH_PATTERN = exports.SEARCH_PATTERN = {
    NONE: 0,
    RASTER: 1,
    SPIRAL_FILL: 2,
    SPIRAL_FRAME: 3,
    RIGHT_DOWN: 4,
    RIGHT_UP: 5,
    DOWN_RIGHT: 6,
    DOWN_LEFT: 7,
    SNAKE_RIGHT_DOWN: 8,
    SNAKE_DOWN_RIGHT: 9
};

function SearchService(cpStart, csRegion, ePattern) {
    if (ePattern === undefined) {
        // ('Search: undefined search pattern'); // eslint-disable-line no-undef
        return;
    }
    var m_cpCurrent = new _objects.Point(cpStart.x, cpStart.y);
    var m_csRegion = new _objects.Size(csRegion.w, csRegion.h);
    var m_ePattern = ePattern;
    var m_bInProgress = false;
    var m_bSearchIsComplete = false;
    var m_nCurCount = 0;
    var m_nMaxCount = m_csRegion.getArea();
    var m_nRadius = 0;
    var m_nDirCurrent = 0;
    var m_nDirCountDown = 0;
    var m_nDirSecondary = 0;

    // prohibit processing if settings aren't reasonable
    if (m_csRegion.w < 1 || m_csRegion.h < 1 || m_cpCurrent.x < 0 || m_cpCurrent.y < 0) {
        m_ePattern = SEARCH_PATTERN.NONE;
        m_bSearchIsComplete = true;
    }

    // spiral motion is in a clockwise direction as defined by this order
    var eSPIRAL_DIR = { eMOVE_RIGHT: 0, eMOVE_DOWN: 1, eMOVE_LEFT: 2, eMOVE_UP: 3 };
    var m_cpPropDirInc = (0, _helpers.array2DCreate)(2, 4); //index [0] is for X direction; index [1] is Y
    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_RIGHT] = +1;
    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_RIGHT] = 0;
    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_DOWN] = 0;
    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_DOWN] = +1;
    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_LEFT] = -1;
    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_LEFT] = 0;
    m_cpPropDirInc[0][eSPIRAL_DIR.eMOVE_UP] = 0;
    m_cpPropDirInc[1][eSPIRAL_DIR.eMOVE_UP] = -1;

    switch (m_ePattern) {
        case SEARCH_PATTERN.SPIRAL_FILL:
            // because the spiral can be started anywhere in the region
            // the algorithm insures that it covers the region by allowing spiraling
            // out of and then back into the region.  The worst case total count must is computed as safety stopping criteria.
            m_csRegion = new _objects.Size(csRegion.w - 1, csRegion.h - 1); // search is inclusive of the last row and col so redefine region w,h
            m_nRadius = 0;
            var nXRadius = Math.max(m_csRegion.w - m_cpCurrent.x + 1, m_csRegion.w);
            var nYRadius = Math.max(m_csRegion.h - m_cpCurrent.y + 1, m_csRegion.h);
            var nDiamMax = Math.max(2 * nXRadius, 2 * nYRadius);
            m_nMaxCount = nDiamMax * nDiamMax;
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
            m_nDirCountDown = 1;
            break;
        case SEARCH_PATTERN.SPIRAL_FRAME:
            //  the sprial frame starts one to the right of the diagonal inner boundary
            m_csRegion = new _objects.Size(csRegion.w - 1, csRegion.h - 1); // search is inclusive of the last row and col so redefine region w,h
            m_nRadius = m_csRegion.w - 2 * m_cpCurrent.x - 1;
            m_cpCurrent.x++; //start one step to the right but requries input diagonal ...
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
            m_nDirCountDown = 1; // so first entry switches to direction right
            break;
        case SEARCH_PATTERN.RIGHT_DOWN:
        case SEARCH_PATTERN.RIGHT_UP:
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;
            m_nDirSecondary = m_ePattern == SEARCH_PATTERN.RIGHT_DOWN ? eSPIRAL_DIR.eMOVE_DOWN : eSPIRAL_DIR.eMOVE_UP;
            break;
        case SEARCH_PATTERN.DOWN_RIGHT:
        case SEARCH_PATTERN.DOWN_LEFT:
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN;
            m_nDirSecondary = m_ePattern == SEARCH_PATTERN.DOWN_RIGHT ? eSPIRAL_DIR.eMOVE_RIGHT : eSPIRAL_DIR.eMOVE_LEFT;
            break;
        case SEARCH_PATTERN.SNAKE_RIGHT_DOWN:
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT; //and left....
            m_nDirSecondary = eSPIRAL_DIR.eMOVE_DOWN;
            break;
        case SEARCH_PATTERN.SNAKE_DOWN_RIGHT:
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN; //and up....
            m_nDirSecondary = eSPIRAL_DIR.eMOVE_RIGHT;
            break;
    }

    //............................................ get next point in pattern - PUBLIC
    this.next = function () {
        if (m_bSearchIsComplete) {
            return;
        }

        if (m_bInProgress == false) {
            // if just starting, return current point
            m_bInProgress = true;
            return new _objects.Point(m_cpCurrent.x, m_cpCurrent.y);
        }

        switch (m_ePattern) {// otherwise call on the pattern sequencing method
            case SEARCH_PATTERN.SPIRAL_FILL:
                return nextSpiral();
                break;
            case SEARCH_PATTERN.SPIRAL_FRAME:
                return nextFrame();
                break;
            case SEARCH_PATTERN.RIGHT_DOWN:
            case SEARCH_PATTERN.RIGHT_UP:
                return nextRasterX();
                break;
            case SEARCH_PATTERN.DOWN_RIGHT:
            case SEARCH_PATTERN.DOWN_LEFT:
                return nextRasterY();
                break;
            case SEARCH_PATTERN.SNAKE_RIGHT_DOWN:
                return nextSnakeX();
                break;
            case SEARCH_PATTERN.SNAKE_DOWN_RIGHT:
                return nextSnakeY();
                break;
            default:
                return;
        }
    };
    //............................................ get next point in snake X direction pattern - PRIVATE
    function nextSnakeX() {
        if (m_nCurCount > m_nMaxCount) {
            // is it time to stop
            m_bSearchIsComplete = true;
            return;
        }
        m_nCurCount++;
        m_cpCurrent.x += m_cpPropDirInc[0][m_nDirCurrent];

        if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_RIGHT && m_cpCurrent.x >= m_csRegion.w) {
            m_cpCurrent.x = m_csRegion.w - 1; // x resets to 0
            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_LEFT; // and switch right motion for left
        } else if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_LEFT && m_cpCurrent.x < 0) {
            m_cpCurrent.x = 0; // x resets to 0
            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT; // and switch right motion for left
        }
        if (m_cpCurrent.y < m_csRegion.h && m_cpCurrent.y >= 0) {
            return new _objects.Point(m_cpCurrent);
        }
    }

    function nextSnakeY() {
        if (m_nCurCount > m_nMaxCount) {
            // is it time to stop
            m_bSearchIsComplete = true;
            return;
        }
        m_nCurCount++;
        m_cpCurrent.y += m_cpPropDirInc[1][m_nDirCurrent];

        if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_DOWN && m_cpCurrent.y >= m_csRegion.h) {
            m_cpCurrent.y = m_csRegion.h - 1;
            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_UP;
        } else if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_UP && m_cpCurrent.y < 0) {
            m_cpCurrent.y = 0;
            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
            m_nDirCurrent = eSPIRAL_DIR.eMOVE_DOWN;
        }

        if (m_cpCurrent.x < m_csRegion.w && m_cpCurrent.x >= 0) {
            return new _objects.Point(m_cpCurrent);
        }
    }

    function nextSpiral() {
        do {
            if (++m_nCurCount > m_nMaxCount) {
                // is it time to stop?
                m_bSearchIsComplete = true;
                return;
            }

            m_nDirCountDown--;
            if (!m_nDirCountDown) {
                // if its time to switch directions
                m_nDirCurrent++;
                if (m_nDirCurrent > eSPIRAL_DIR.eMOVE_UP) m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;

                if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_RIGHT || m_nDirCurrent == eSPIRAL_DIR.eMOVE_LEFT) m_nRadius++;
                m_nDirCountDown = m_nRadius;
            }
            m_cpCurrent.add(m_cpPropDirInc[0][m_nDirCurrent], m_cpPropDirInc[1][m_nDirCurrent]);
        } while (m_cpCurrent.x < 0 || m_cpCurrent.x > m_csRegion.w || m_cpCurrent.y < 0 || m_cpCurrent.y > m_csRegion.h);

        return new _objects.Point(m_cpCurrent);
    }

    function nextFrame() {
        do {
            if (++m_nCurCount > m_nMaxCount) {
                // is it time to stop
                m_bSearchIsComplete = true;
                return;
            }

            m_nDirCountDown--;
            if (m_nDirCountDown <= 0) {
                // if its time to switch directions
                m_nDirCurrent++;
                if (m_nDirCurrent > eSPIRAL_DIR.eMOVE_UP) m_nDirCurrent = eSPIRAL_DIR.eMOVE_RIGHT;

                if (m_nDirCurrent == eSPIRAL_DIR.eMOVE_UP || m_nDirCurrent == eSPIRAL_DIR.eMOVE_DOWN) m_nRadius++;
                m_nDirCountDown = m_nRadius;
            }
            m_cpCurrent.add(m_cpPropDirInc[0][m_nDirCurrent], m_cpPropDirInc[1][m_nDirCurrent]);
        } while (m_cpCurrent.x < 0 || m_cpCurrent.x > m_csRegion.w || m_cpCurrent.y < 0 || m_cpCurrent.y > m_csRegion.h);

        return new _objects.Point(m_cpCurrent);
    }

    function nextRasterX() {
        if (m_nCurCount > m_nMaxCount) {
            // is it time to stop
            m_bSearchIsComplete = true;
            return;
        }
        m_nCurCount++;
        m_cpCurrent.x += m_cpPropDirInc[0][m_nDirCurrent];
        if (m_cpCurrent.x >= m_csRegion.w) {
            // if too far right
            m_cpCurrent.x = 0; // x resets to 0
            m_cpCurrent.y += m_cpPropDirInc[1][m_nDirSecondary]; // move y up or down
        }
        if (m_cpCurrent.y < m_csRegion.h && m_cpCurrent.y >= 0) {
            return new _objects.Point(m_cpCurrent);
        }
    }

    function nextRasterY() {
        if (m_nCurCount > m_nMaxCount) {
            // is it time to stop
            m_bSearchIsComplete = true;
            return;
        }
        m_nCurCount++;
        m_cpCurrent.y += m_cpPropDirInc[1][m_nDirCurrent];
        if (m_cpCurrent.y >= m_csRegion.h) {
            m_cpCurrent.y = 0;
            m_cpCurrent.x += m_cpPropDirInc[0][m_nDirSecondary];
        }
        if (m_cpCurrent.x < m_csRegion.w && m_cpCurrent.x >= 0) {
            return new _objects.Point(m_cpCurrent);
        }
    }
}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(341);


/***/ })

},[627]);